import { useAppSelector } from '@store/hooks';
import { selectSelectedFloor } from '@store/selectors/monitor.selectors';
import styles from './leftRail.module.css';

export function FloorViewCard() {
  const floor = useAppSelector(selectSelectedFloor);

  // No floor selected → render nothing. The FloorDrawer (which mounts on
  // `selectedFloorId`) covers the "selected" state in a richer way; the
  // empty placeholder card here was only adding visual noise.
  if (!floor) return null;

  const label = String(floor.floorNick || floor.shortFloorNick || floor.floorId);
  const workers = floor.activeProfessions.reduce(
    (sum, p) => sum + p.activeTagsIds.length,
    0,
  );
  // Derive alert count from active professions tagging safety events is done at
  // selector level via selectFloorSummaries; here we just show the worker count.
  const hasAlert = false; // refined by Task 5 with real alertsCount

  return (
    <div className={styles.floorCard}>
      <div className={styles.floorPlan}>
        <MiniFloorPlan alert={hasAlert} />
      </div>
      <div className={styles.floorInfo}>
        <span className={styles.floorLabel}>Selected floor</span>
        <span className={styles.floorName}>{label}</span>
        <div className={styles.floorStats}>
          <div className={styles.floorStat}>
            <span className={styles.statValue}>{workers}</span>
            <span className={styles.statLabel}>Workers</span>
          </div>
        </div>
      </div>
    </div>
  );
}

function MiniFloorPlan({ alert }: { alert: boolean }) {
  return (
    <svg viewBox="0 0 88 88" aria-hidden="true">
      <rect x="8" y="10" width="72" height="68" fill="#fff" stroke="#cfd2d6" strokeWidth="1.2" />
      <line x1="8"  y1="34" x2="80" y2="34" stroke="#e7e9eb" strokeWidth="1" />
      <line x1="8"  y1="56" x2="80" y2="56" stroke="#e7e9eb" strokeWidth="1" />
      <line x1="40" y1="10" x2="40" y2="78" stroke="#e7e9eb" strokeWidth="1" />
      <rect x="36" y="52" width="10" height="10" fill="#f4f7f8" stroke="#cfd2d6" strokeWidth="0.6" />
      {alert ? <circle cx="66" cy="22" r="4" fill="#ff837a" /> : null}
    </svg>
  );
}
